export default __webpack_public_path__ + "static/media/process-circle2.9b7c953f.png";